var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"live_lesson_page"},[_c('div',{staticClass:"handle_link"},[_c('a',{attrs:{"href":"https://v.qq.com/","target":"_blank"}},[_vm._v(_vm._s(_vm.$t('examResume.jump')))]),_vm._v(" "),_c('button',{on:{"click":_vm.goto_lesson}},[_vm._v(_vm._s(_vm.$t('common.returnButton')))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ef5f815","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/exam/liveLesson.vue
// module id = null
// module chunks = 